import React from 'react';
import { ConfigProvider } from 'antd';
import { RawIntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { generateIntl } from 'utils/intl';

import english from './locales/en-US';
import albanian from './locales/al-AL';

const locales = {
  'en-US': english,
  'al-AL': albanian,
};

const Localization = ({ children }) => {
  const { locale } = useSelector(state => state.settings);
  const currentLocale = locales[locale];
  const intlValue = generateIntl({
    locale: currentLocale.locale,
    messages: currentLocale.messages,
  });

  return (
    <ConfigProvider locale={currentLocale.localeAntd}>
      <RawIntlProvider value={intlValue} onError={() => {}}>
        {children}
      </RawIntlProvider>
    </ConfigProvider>
  );
};

export default Localization;
